@if(!!items.length) {
<div class="se-side-search-button-container">
    @if(!!items.length && enableAllBusinessUnitExaminationSearch) {
    <button (click)="reLoadEprEventsRequired()"
            class="se-button-no-ripple se-flex-1"
            color="primary"
            mat-button
            matTooltip="{{'AllBusinessUnitSearch' | translate}}"
            matTooltipShowDelay="500">
        <mat-icon class="search-filter-search-icon">search</mat-icon>
    </button>
    }
</div>
}

<!--Icone per info su warning/errori con tooltip esplicativo-->
<div class="se-side-info-icons-container"
     [matTooltip]="clinicalHistoryTooltip"
     [matTooltipDisabled]="isLoading | async">
    @if(isLoading | async) {
    <div class="mini-spinner">
        <mat-spinner></mat-spinner>
    </div>
    }
    @else if (
    clinicalHistoryState() === 'INCOMPLETE' ||
    clinicalHistoryState() === 'ERROR'
    ) {
    <div class="error-icon">
        <mat-icon>error</mat-icon>
    </div>
    }
    @else if (
    clinicalHistoryState() === 'SUCCESS' ||
    clinicalHistoryState() === 'SUCCESS_NO_RESULT'
    ) {
    <div class="success-icon">
        <mat-icon>check</mat-icon>
    </div>
    }
</div>

<!--componente snackbar per info su warning/errori-->
<se-side-snackbar />

<div class="se-side-patient-history-container">
    @if(!!items.length) {
    <div class="se-side-patient-history-items-container">
        @for(item of items; track item.id) {
        <div class="items-inner-container">
            <se-side-patient-history-item [item]="item"
                                          [expandedItemId]="expandedItemId"
                                          [isCp]="isAnyExaminationActive"
                                          (historySelectionChanged)="onHistorySelectionChanged($event)">
            </se-side-patient-history-item>
        </div>
        }
    </div>
    }

    @if(isLoading | async) {
    <div class="estensa-spinner">
        <mat-spinner></mat-spinner>
    </div>
    }

    @if(!!!items.length) {
    <div class="se-side-patient-history-text-container">
        <span>{{patientHistoryMessage}}</span>
    </div>
    }

</div>
